var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.CONFIG.CALENDAR_SERVICE_ENABLED
    ? _c(
        "div",
        { staticClass: "calendar-today", attrs: { id: "today-event" } },
        [
          _c("div", { on: { click: _vm.goCalendarPage } }, [
            _c("div", { staticClass: "today-date-str" }, [
              _vm._v(_vm._s(_vm.getDayString())),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "today-date-number" }, [
              _vm._v(_vm._s(new Date().getDate())),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "a-popover",
            {
              attrs: {
                id: "calendarTodayEvents",
                placement: "bottom",
                trigger: "hover",
                overlayClassName: "calendarTodayEvents",
              },
            },
            [
              _vm.todayEvents.length > 0
                ? _c(
                    "template",
                    { slot: "content" },
                    [
                      _c("div", { staticClass: "add-event-popover" }, [
                        _c(
                          "div",
                          {
                            staticClass: "material-icons add-event-btn",
                            on: { click: _vm.openAddEvent },
                          },
                          [_vm._v("add")]
                        ),
                        _vm._v(" "),
                        _c("div", [_vm._v("Add Event")]),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.todayEvents, function (todayEvent) {
                        return _c(
                          "div",
                          { staticClass: "calendar-event event-popover" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "event-summary",
                                on: {
                                  click: function ($event) {
                                    return _vm.goCalendarPage(todayEvent)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(todayEvent.summary))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "event-date",
                                on: {
                                  click: function ($event) {
                                    return _vm.goCalendarPage(todayEvent)
                                  },
                                },
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.getEventTime(
                                          todayEvent.start,
                                          todayEvent.isAllDay
                                        )
                                      ) +
                                      " -\n                        " +
                                      _vm._s(
                                        _vm.getEventTime(
                                          todayEvent.end,
                                          todayEvent.isAllDay
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", {}, [
                _vm.todayEvents.length > 0
                  ? _c("div", { staticClass: "calendar-event header-event" }, [
                      _c(
                        "div",
                        {
                          staticClass: "event-summary",
                          on: {
                            click: function ($event) {
                              return _vm.goCalendarPage(_vm.todayEvents[0])
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.todayEvents[0].summary) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "event-date",
                          on: {
                            click: function ($event) {
                              return _vm.goCalendarPage(_vm.todayEvents[0])
                            },
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.getEventTime(
                                    _vm.todayEvents[0].start,
                                    _vm.todayEvents[0].isAllDay
                                  )
                                ) +
                                " -\n                        " +
                                _vm._s(
                                  _vm.getEventTime(
                                    _vm.todayEvents[0].end,
                                    _vm.todayEvents[0].isAllDay
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.todayEvents.length > 1
                            ? _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.goCalendarPage(
                                        _vm.todayEvents[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        + " +
                                      _vm._s(_vm.todayEvents.length) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "material-icons add-event-btn",
                                  on: { click: _vm.openAddEvent },
                                },
                                [_vm._v("add")]
                              ),
                        ]
                      ),
                    ])
                  : _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "material-icons add-event-btn",
                          on: { click: _vm.openAddEvent },
                        },
                        [_vm._v("add")]
                      ),
                    ]),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _vm.openCalendarAddEventModal
            ? _c("CreateEventModal", {
                on: {
                  close: function ($event) {
                    _vm.openCalendarAddEventModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }